import React from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './simulatedCorrectionFinishedConfirmationModalMessages';

function SimulatedFinishedConfirmationModal(props) {
  // SA-1853 - the same modal reports the failure so the user is never left with a
  // request that silently went nowhere.
  const title = props.error ? messages.errorTitle : messages.title;
  const subtitle = props.error ? messages.errorSubtitle : messages.subtitle;

  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon={props.error ? 'ti ti-close' : 'ti ti-check-box'}
      title={props.intl.formatMessage(title)}
      subtitle={
        <div
          dangerouslySetInnerHTML={{
            __html: props.intl.formatMessage(subtitle, {
              evaluationName: props.evaluation.title,
              idEvaluation: props.idEvaluation,
            }),
          }}
        />
      }
      buttons={[
        {
          label: props.intl.formatMessage(messages.continue),
          onClick: props.onClose,
          primary: true,
        },
      ]}
    />
  );
}

SimulatedFinishedConfirmationModal.defaultProps = {
  error: false,
};

export default injectIntl(SimulatedFinishedConfirmationModal);
